import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Container,
} from "@mui/material";
import {
  Google as GoogleIcon,
} from "@mui/icons-material";

const LoginButton: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            padding: 6,
            textAlign: "center",
            backgroundColor: "white",
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            maxWidth: 400,
            margin: "0 auto",
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              color: "#333",
              mb: 1,
              fontSize: "2rem",
            }}
          >
            Orchestrator Console
            <span style={{ color: "#FF006F" }}>.</span>
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: "#333",
              mb: 1,
              fontWeight: 500,
            }}
          >
            Olá! Você está no Orchestrator Console
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#666",
              mb: 4,
              lineHeight: 1.5,
            }}
          >
            Faça login via Auth0, com seu e-mail corporativo
          </Typography>

          <Button
            fullWidth
            variant="contained"
            size="large"
            startIcon={<GoogleIcon />}
            onClick={() => loginWithRedirect()}
            sx={{
              backgroundColor: "#4285f4",
              color: "white",
              padding: "12px 24px",
              fontSize: "1rem",
              fontWeight: 500,
              borderRadius: 1,
              textTransform: "none",
              boxShadow: "0 2px 8px rgba(66, 133, 244, 0.3)",
              "&:hover": {
                backgroundColor: "#3367d6",
                boxShadow: "0 4px 12px rgba(66, 133, 244, 0.4)",
              },
              transition: "all 0.2s ease",
            }}
          >
            LOGIN COM AUTH0
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default LoginButton;
